// frontend/shared-ui/src/components/FormSection.jsx
import React from "react";

/**
 * A grouped block of form fields with a title, optional description,
 * and optional actions slot. Borderless — assumes it's inside a Card/Panel.
 */
export default function FormSection({
  title,
  description,
  actions,
  children,
  className = "",
  compact = false,
}) {
  return (
    <section
      className={`fh-form-section ${compact ? "is-compact" : ""} ${className}`}
    >
      {(title || description || actions) && (
        <header className="fh-form-section__head">
          <div>
            {title && <h3 className="fh-form-section__title">{title}</h3>}
            {description && (
              <p className="fh-form-section__desc">{description}</p>
            )}
          </div>
          {actions && <div className="fh-form-section__actions">{actions}</div>}
        </header>
      )}
      <div className="fh-form-section__body">{children}</div>
    </section>
  );
}
